import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Row, Col, Tab, Tabs } from "react-bootstrap";
import moment from "moment";
import { Formik } from "formik";
import DatePicker from "react-datepicker";
import Select from "react-select";

import { toast } from "react-toastify";
import ErrorComponent from "../../Component/ErrorComponent";
import { CreateAssignemntSchema, Elibrary } from "../../utils/ValidationSchema";
import SelectStarModal from "../../Component/SelectStar";
import { useEffect } from "react";
import {
  GetFunction,
  SubmitResponse,
  UpdatePutReponse,
} from "../../utils/ApiFunctions";
import { useLocalization } from "../../Component/Localization/Localization";
import { GetValuedynamciLable, GetValueLable, GetValueLableWithId } from "../../utils/Helper";
// import SelectStar from "../Component/SelectStar"

const AddForm = () => {
  const { assessmentType, id } = useParams();
  const [options, setOptions] = useState([]);
  const [options1, setOptions1] = useState([]);
  const [termOptions, setTermsOption] = useState([]);
  const [termList, setTermsList] = useState([]);
  const navigate = useNavigate();
  const [classList, setClassList] = useState([]);
  const [leavetypeList, setLeaveType] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [details, setDetails] = useState([]);
  const [document, setDocument] = useState("");
  const [classId, setClassId] = useState("");
  const [termId, setTermId] = useState("");
  const school = localStorage.getItem("school");
  const [starmodal, setSlectStarModal] = useState(false);
  const [stararraySelected, SetSelectStar] = useState([]);

  async function GetClassList() {
    const res = await GetFunction(
      `class/subject/data/forcreate?school=${school}`
    );
    // const res = await GetFunction(`class/getAllClass`);
    if (res.status == 200) {
      setClassList(res?.data?.data?.class);
    }
  }

  async function GetSubjecList() {
    const res = await GetFunction(
      `/subject/get-all?pages=all&school=${school}&class=${classId}`
    );
    if (res.status == 200) {
      setSubjectList(res?.data?.data);
    }
  }

  async function GetDetails() {
    const res = await GetFunction(`assignments/single/${id}`);
    if (res.status == 200) {
      setDetails(res?.data?.data);
      setTermId(res?.data?.data?.termId);
    }
  }

  async function getTerms() {
    const res = await GetFunction(`paymentslot/get-all?school=${school}`);
    if (res.status == 200) {
      setTermsList(res?.data?.data);
    }
  }

  useEffect(() => {
    GetSubjecList();
  }, [classId]);
  useEffect(() => {
    GetClassList();
    getTerms();
  }, []);

  useEffect(() => {
    if (id) {
      GetDetails();
    }
  }, [id]);

  const handleSubmit = async (values) => {
    const data = new FormData();
    data?.append("category", assessmentType);
    data?.append("class", values?.class);
    data?.append("subject", values?.subject);
    data?.append("title", values?.title);
    data?.append("term", values?.term);
    data?.append("termId", termId);

    // data?.append("link", values?.link);

    const res = await SubmitResponse(`/assignments/create`, data);
    if (res.status == 200) {
      toast.success(res?.data?.message);
      navigate(`/addquestion/${assessmentType}/${res?.data?.data?._id}`);
    }
  };
  const UpdateSubmit = async (values) => {
    const data = new FormData();
    data?.append("category", assessmentType);
    data?.append("class", values?.class);
    data?.append("subject", values?.subject);
    data?.append("title", values?.title);
    data?.append("term", values?.term);
    data?.append("termId", termId);
    // data?.append("link", values?.link);

    const res = await UpdatePutReponse(
      `/assignments/update/${details?._id}`,
      data
    );
    if (res.status == 200) {
      toast.success(res?.data?.message);
      navigate(`/addquestion/${assessmentType}/${details?._id}/1`);

      // navigate(`/elibrary/${assessmentType}`);
    }
  };
  const { t } = useLocalization();

  useEffect(() => {
    setOptions1(GetValueLableWithId(classList, ["_id", "name"]));
  }, [classList]);

  useEffect(() => {
    setOptions(
      GetValuedynamciLable(subjectList, ["_id", "name"], "Select Subject")
    );
    // setOptions(GetValueLableWithId(subjectList, ["_id", "name"]));
  }, [subjectList]);
  useEffect(() => {
    setTermsOption(GetValueLableWithId(termList, ["_id", "name"]));
  }, [termList]);

  const selectOptions = [
    { value: "", label: t("assigned_category") },
    { value: "awarenessCourses", label: t("awareness_courses") },
    { value: "worksheet", label: t("worksheet") },
    // { value: "assessment", label: t("assesment") },
    // { value: "lab", label: t("lab") },
  ];
  return (
    <>
      <div id="main" className="main-section-login">
        <section className="">
          <div className="section-heading plage-steps-dtl my-2">
            <h2 className="performance-heading">
              {/* {id ? "Update" : "Add"}{" "} */}
              {assessmentType == "awarenessCourses"
                ? t("awareness_courses")
                : t(assessmentType)}
            </h2>
          </div>

          <section className="profile-aection bg-light p-3">
            <Row className="mt-2">
              <Col md={8}>
                <Formik
                  initialValues={{
                    title: id ? details?.title : "",
                    subject: id ? details?.subject?._id : "",
                    class: id ? details?.class?._id : "",
                    category: id ? details?.category : "",
                    term: id ? details?.term : "",
                    // link: "",
                  }}
                  onSubmit={id ? UpdateSubmit : handleSubmit}
                  validationSchema={Elibrary}
                  enableReinitialize
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    setFieldValue,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <form
                      className="cmn-frm without-icon add-filds"
                      onSubmit={handleSubmit}
                    >
                      <Row>
                        <Col md={6}>
                          <div className="form-group">
                            <input
                              type="text"
                              name="title"
                              placeholder={t("title")}
                              onChange={handleChange}
                              value={values.title}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.title && touched.title && errors.title
                            }
                          />
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            {/* <select
                              onChange={handleChange}
                              value={values.category}
                              name="category"
                            >
                              <option value="" defaultValue>
                                {t("assigned_category")}:
                              </option>
                              <option value="awarenessCourses">
                                {t("awareness_courses")}
                              </option>
                              <option value="worksheet">
                                {" "}
                                {t("worksheet")}
                              </option>
                              <option value="assessment">
                                {t("assesment")}
                              </option>
                              <option value="lab">{t("lab")}</option>
                            </select> */}
                            <Select
                              placeholder={t("assigned_category")}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999, // Set the desired z-index value
                                  padding: "5px",
                                }),
                                control: (provided) => ({
                                  ...provided,
                                  borderColor: "#AEAEAE", // Set border color to #AEAEAE
                                  "&:hover": {
                                    borderColor: "#AEAEAE", // Set border color when hovering
                                  },
                                  padding: "8px",
                                }),
                              }}
                              options={selectOptions}
                              name="category"
                              onChange={(option) => {
                                handleChange({
                                  target: {
                                    name: "category",
                                    value: option ? option.value : "",
                                  },
                                });
                              }}
                              value={selectOptions.find(
                                (option) => option.value === values.category
                              )}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.category &&
                              touched.category &&
                              errors.category
                            }
                          />
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            {/* <select
                              onChange={handleChange}
                              value={values.class}
                              name="class"
                            >
                              <option selected value="" disabled>
                                {t("class")}:
                              </option>

                              {classList &&
                                classList?.map((val, i) => (
                                  <option value={val?._id}>{val?.name}</option>
                                ))}
                            </select> */}
                            <Select
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999, // Set the desired z-index value
                                  padding: "5px",
                                }),
                                control: (provided) => ({
                                  ...provided,
                                  borderColor: "#AEAEAE", // Set border color to #AEAEAE
                                  "&:hover": {
                                    borderColor: "#AEAEAE", // Set border color when hovering
                                  },
                                  padding: "8px",
                                }),
                              }}
                              placeholder={t("class")}
                              options={options1}
                              name="class"
                              onChange={(option) => {
                                handleChange({
                                  target: {
                                    name: "class",
                                    value: option ? option.value : "",
                                  },
                                });
                                setClassId(option.value);
                              }}
                              value={options1.find(
                                (option) => option.value === values.class
                              )}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.class && touched.class && errors.class
                            }
                          />
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            {/* <select
                              onChange={handleChange}
                              value={values.subject}
                              name="subject"
                            >
                              <option selected value="" disabled>
                                {t("subject")}:
                              </option>
                              {subjectList &&
                                subjectList?.map((val, i) => (
                                  <option value={val?._id}>{val?.name}</option>
                                ))}
                            </select> */}

                            <Select
                              placeholder={t("subject")}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999, // Set the desired z-index value
                                  padding: "5px",
                                }),
                                control: (provided) => ({
                                  ...provided,
                                  borderColor: "#AEAEAE", // Set border color to #AEAEAE
                                  "&:hover": {
                                    borderColor: "#AEAEAE", // Set border color when hovering
                                  },
                                  padding: "8px",
                                }),
                              }}
                              options={classId ? options : []}
                              // options={options}
                              name="class"
                              onChange={(option) => {
                                handleChange({
                                  target: {
                                    name: "subject",
                                    value: option ? option.value : "",
                                  },
                                });
                              }}
                              value={options.find(
                                (option) => option.value === values.subject
                              )}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.subject &&
                              touched.subject &&
                              errors.subject
                            }
                          />
                        </Col>

                        {/* <Col md={6}>
                          <div className="form-group">
                            <input
                              type="text"
                              name="term"
                              placeholder={t("term")}
                              onChange={handleChange}
                              value={values.term}
                            />
                          </div>
                          <ErrorComponent
                            error={errors.term && touched.term && errors.term}
                          />
                        </Col> */}

                        <Col md={6}>
                          <div className="form-group">
                            <Select
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999, // Set the desired z-index value
                                  padding: "5px",
                                }),
                                control: (provided) => ({
                                  ...provided,
                                  borderColor: "#AEAEAE", // Set border color to #AEAEAE
                                  "&:hover": {
                                    borderColor: "#AEAEAE", // Set border color when hovering
                                  },
                                  padding: "8px",
                                }),
                              }}
                              placeholder={t("term")}
                              options={termOptions}
                              name="term"
                              onChange={(option) => {
                                handleChange({
                                  target: {
                                    name: "term",
                                    value: option ? option.label : "",
                                  },
                                });
                                setTermId(option.value);
                              }}
                              value={termOptions.find(
                                (option) => option.label == values.term
                              )}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.class && touched.class && errors.class
                            }
                          />
                        </Col>

                        {/* <Col md={6}>
                          <div className="form-group">
                            <input
                              type="text"
                              name="link"
                              placeholder={t("link")}
                              onChange={handleChange}
                              value={values.link}
                            />
                          </div>
                          <ErrorComponent
                            error={errors.link && touched.link && errors.link}
                          />
                        </Col> */}
                        <Col md={12}>
                          <div>
                            <button
                              className="btn-btn-primary px-5"
                              type="submit"
                            >
                              {t("save_next")}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  )}
                </Formik>
              </Col>
            </Row>
          </section>
        </section>
      </div>
      <SelectStarModal
        show={starmodal}
        onHide={() => setSlectStarModal(false)}
        Selectdata={(data) => {
          SetSelectStar(data);
        }}
        prevoiusdata={stararraySelected}
      />
    </>
  );
};

export default AddForm;
